<template>
  <div class="frontkey-split">
    <!-- Left: existing settings UI (unchanged) -->
    <div class="pane pane-left">
      <SettingGroup title="アップ">
        <SettingItem label="ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.up.function"
            :defaultValue="String(form.selectbox.up.function)"
            @update="handleSelectUpFunction"
          />
        </SettingItem>
        <SettingItem label="ホールド・ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.up.holdFunction"
            :defaultValue="String(form.selectbox.up.holdFunction)"
            @update="handleSelectUpHoldFunction"
          />
        </SettingItem>
      </SettingGroup>

      <SettingGroup title="ダウン">
        <SettingItem label="ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.down.function"
            :defaultValue="String(form.selectbox.down.function)"
            @update="handleSelectDownFunction"
          />
        </SettingItem>
        <SettingItem label="ホールド・ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.down.holdFunction"
            :defaultValue="String(form.selectbox.down.holdFunction)"
            @update="handleSelectDownHoldFunction"
          />
        </SettingItem>
      </SettingGroup>

      <SettingGroup title="決定">
        <SettingItem label="ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.enter.function"
            :defaultValue="String(form.selectbox.enter.function)"
            @update="handleSelectEnterFunction"
          />
        </SettingItem>
        <SettingItem label="ホールド・ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.enter.holdFunction"
            :defaultValue="String(form.selectbox.enter.holdFunction)"
            @update="handleSelectEnterHoldFunction"
          />
        </SettingItem>
      </SettingGroup>

      <SettingGroup title="戻る">
        <SettingItem label="ファンクション">
          <SelectBox
            :disabled="false"
            :options="selectboxOptions.back.function"
            :defaultValue="String(form.selectbox.back.function)"
            @update="handleSelectBackFunction"
          />
        </SettingItem>
      </SettingGroup>
    </div>

    <!-- Right: fixed guide image -->
    <div class="pane pane-right">
      <div class="guide-header">
        <div class="guide-title">フロントキー</div>
      </div>

      <div class="guide-wrap">
        <img class="guide-image" :src="frontGuideImage" alt="KBX-P51 front guide" />
      </div>
    </div>
  </div>
</template>

<script>
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { FUNCTION_LIST } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'
import frontGuideImage from '@/assets/IP_Radio/KBX-P51_front_guide.png'

export default {
  name: 'FrontKeyAssignmentVue2',
  components: { SelectBox, SettingGroup, SettingItem },
  data () {
    const toOptions = (pick) =>
      FUNCTION_LIST.map(ele => {
        if (ele.type.key && ele.function && ele.function[pick]) {
          return { label: ele.label, value: ele.value }
        }
      }).filter(Boolean)

    const initial = {
      up:   { function: toOptions('function'),      holdFunction: toOptions('holdFunction') },
      down: { function: toOptions('function'),      holdFunction: toOptions('holdFunction') },
      enter:{ function: toOptions('function'),      holdFunction: toOptions('holdFunction') },
      back: { function: toOptions('function'),      holdFunction: toOptions('holdFunction') }, // 表示はしない
    }

    return {
      // UI 選択肢
      selectboxOptions: initial,

      // 右ペイン固定表示画像
      frontGuideImage,

      // フォーム（※元コード同様、初期は label を格納）
      form: {
        selectbox: {
          up: {
            function: initial.up.function[0]?.label || 'None',
            holdFunction: initial.up.holdFunction[0]?.label || 'None',
          },
          down: {
            function: initial.down.function[0]?.label || 'None',
            holdFunction: initial.down.holdFunction[0]?.label || 'None',
          },
          enter: {
            function: initial.enter.function[0]?.label || 'None',
            holdFunction: initial.enter.holdFunction[0]?.label || 'None',
          },
          back: {
            function: initial.back.function[0]?.label || 'None',
            holdFunction: initial.back.holdFunction[0]?.label || 'None', // 設定不可
          },
        },
      },

      // ストアの一時設定
      setting: null,
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),
  },
  created () {
    // ストアから設定取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォーム
    this.transSetting2Form()

    // 選択肢の初期再構成
    this.updateSelectboxOptions('up')
    this.updateSelectboxOptions('down')
    this.updateSelectboxOptions('enter')
    this.updateSelectboxOptions('back')

    // フォーム変更を監視して 設定 ← フォーム & 保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  methods: {
    deepCopy (o) { try { return JSON.parse(JSON.stringify(o)) } catch (_) { return {} } },

    // ====== 設定 ← フォーム ======
    transForm2Setting () {
      // console.log('before setting:', this.deepCopy(this.setting.KeyAssignment.Front))
      this.keyTransForm2Setting('up')
      this.keyTransForm2Setting('down')
      this.keyTransForm2Setting('enter')
      this.keyTransForm2Setting('back')
      // console.log('after setting:', this.deepCopy(this.setting.KeyAssignment.Front))
    },
    keyTransForm2Setting (key) {
      const data = this.setting.KeyAssignment.Front
      const K = key.charAt(0).toUpperCase() + key.slice(1)

      const func = this.form.selectbox[key].function
      const hold = this.form.selectbox[key].holdFunction

      const isPress =
        hold === 'None' ||
        (func === 'GroupDown' && hold === 'GroupDown(Continuous)') ||
        (func === 'GroupUp'   && hold === 'GroupUp(Continuous)')

      data[K]['Function(Press)']   = isPress ? func : 'None'
      data[K]['Function(Release)'] = !isPress ? func : 'None'
      data[K].HoldFunction         = hold
    },

    // ====== 設定 → フォーム ======
    transSetting2Form () {
      // console.log('before form:', this.deepCopy(this.form))
      this.keyTransSetting2Form('up')
      this.keyTransSetting2Form('down')
      this.keyTransSetting2Form('enter')
      this.keyTransSetting2Form('back')
      // console.log('after form:', this.deepCopy(this.form))
    },
    keyTransSetting2Form (key) {
      const data = this.setting.KeyAssignment.Front
      const K = key.charAt(0).toUpperCase() + key.slice(1)

      const press = data[K]['Function(Press)']
      const hold  = data[K].HoldFunction

      const isPress =
        hold === 'None' ||
        (press === 'GroupDown' && hold === 'GroupDown(Continuous)') ||
        (press === 'GroupUp'   && hold === 'GroupUp(Continuous)')

      this.form.selectbox[key].function     = isPress ? data[K]['Function(Press)'] : data[K]['Function(Release)']
      this.form.selectbox[key].holdFunction = hold
    },

    // ====== 選択肢の再構成 ======
    updateSelectboxOptions (key) {
      const menuData = this.setting?.KeyAssignment?.Menu || []
      const extMenu  = this.setting?.KeyAssignment?.ExtendedMenu || []

      const hasMenuAutoBacklight =
        menuData.some(item => (item.Function || []).includes('AutoBacklight')) ||
        extMenu.some(item => (item.Function || []).includes('AutoBacklight'))

      const formFunction = this.form.selectbox[key].function

      // function: AutoBacklight を除外、Front では SecondPTT は選べない
      this.selectboxOptions[key].function = FUNCTION_LIST.map(ele => {
        if (
          ele.type.key &&
          ele.function?.function &&
          !(hasMenuAutoBacklight && ele.value === 'Backlight') &&
          ele.value !== 'SecondPTT'
        ) {
          return { label: ele.label, value: ele.value }
        }
      }).filter(Boolean)

      // holdFunction
      this.selectboxOptions[key].holdFunction = FUNCTION_LIST.map(ele => {
        if (
          (ele.type.key && ele.function?.holdFunction &&
            !(hasMenuAutoBacklight && ele.value === 'Backlight')) ||
          (formFunction === 'GroupDown' && ele.value === 'GroupDown(Continuous)') ||
          (formFunction === 'GroupUp'   && ele.value === 'GroupUp(Continuous)')
        ) {
          return { label: ele.label, value: ele.value }
        }
      }).filter(Boolean)
    },

    // ====== ハンドラ ======
    handleSelectFunction (key, value) {
      this.form.selectbox[key].function = value

      // デフォルトのホールド値に切替（戻るキーは設定不可なのでスキップ）
      if (key !== 'back') {
        const holdDefault = FUNCTION_LIST.find(e => e.value === value)?.function?.holdFunctionDefault
        if (holdDefault) this.form.selectbox[key].holdFunction = holdDefault
      }

      // 選択肢を更新
      this.updateSelectboxOptions(key)
    },
    handleSelectUpFunction (v)    { this.handleSelectFunction('up', v) },
    handleSelectDownFunction (v)  { this.handleSelectFunction('down', v) },
    handleSelectEnterFunction (v) { this.handleSelectFunction('enter', v) },
    handleSelectBackFunction (v)  { this.handleSelectFunction('back', v) },

    handleSelectUpHoldFunction (v)    { this.form.selectbox.up.holdFunction = v },
    handleSelectDownHoldFunction (v)  { this.form.selectbox.down.holdFunction = v },
    handleSelectEnterHoldFunction (v) { this.form.selectbox.enter.holdFunction = v },
  },
}
</script>

<style scoped>
.frontkey-split {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

.pane {
  min-width: 0;
}

.pane-left {
  flex: 1 1 60%;
}

/* Make sure tall guide image is fully visible (no cropping) by scaling down */
.pane-right {
  flex: 1 1 40%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.guide-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.guide-title {
  font-weight: 600;
}

.guide-wrap {
  margin-top: 12px;
}

.guide-image {
  display: block;
  width: 100%;
  height: auto;
}

@media (max-width: 900px) {
  .frontkey-split {
    flex-direction: column;
  }
}
</style>
